import Icon from '../components/Icon.vue'

Icon.register({
  cube: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M239.1 6.3L31.1 84.3C12.4 91.3 0 109.3 0 129.3V354.4C0 372.6 10.3 389.2 26.5 397.3L234.5 501.3C248 508.1 263.9 508.1 277.4 501.3L485.4 397.3C501.7 389.2 511.9 372.5 511.9 354.4V129.3C511.9 109.3 499.5 91.4 480.8 84.4L272.8 6.4C262 2.2 250 2.2 239.1 6.3zM256 68.4L448 140.4V141.5L256 219.5 64 141.5V140.4L256 68.4zM288 424.4V275.5L448 210.5V344.4L288 424.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cube.js
// module id = bKIH
// module chunks = 144